var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2727 2.86898C22.2727 2.86898 26.7999 2 30 2C33.2001 2 37.7272 2.86898 37.7272 2.86898",
    stroke: "#F58634",
    strokeWidth: 2.72727,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7531 57.5662C58.5405 60.0538 56.5376 61.9944 54.0465 62.1613L29.9266 63.7781L5.84536 62.1639C3.3373 61.9958 1.32673 60.0316 1.13206 57.5254C0.691359 51.852 -1.92277e-06 41.7842 -2.56327e-06 34.4577C-3.20632e-06 27.1021 0.696846 16.9834 1.13728 11.3227C1.32991 8.84685 3.29656 6.89366 5.77137 6.68861L29.5049 4.72214C29.7855 4.69889 30.0676 4.69889 30.3482 4.72214L54.1199 6.69176C56.5778 6.89541 58.537 8.82533 58.7474 11.2827C59.231 16.9338 60 27.0788 60 34.4577C60 41.8077 59.237 51.9022 58.7531 57.5662Z",
    fill: "#A098AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7271 65.6364C37.7271 65.6364 33.1999 66.5054 29.9998 66.5054C26.7997 66.5054 22.2725 65.6364 22.2725 65.6364",
    stroke: "#F58634",
    strokeWidth: 2.72727,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare2);
export default __webpack_public_path__ + "static/media/square2.c3fa2e3bd8bd778fb9a3d223e8f0a3fc.svg";
export { ForwardRef as ReactComponent };